<template>
  <div class="select-data-option" @click="handleClick">
    <div class="select-data-option--icon" :class="{ 'is-checked': rowData.checked }">
      <x-svg-icon :name="(selectType === 'SINGLE' ? 'radio' : 'checkbox') + (rowData.checked ? '-active' : '')"></x-svg-icon>
    </div>
    <div class="select-data-option--body">
      <form-list-card :columns="colConfigs" :data="rowData.extra" :len="-1" :inTable="true"></form-list-card>
    </div>
  </div>
</template>

<script>
import FormListCard from '@/lib/ui/components/form/form-list-card'

export default {
  components: {
    FormListCard
  },
  props: {
    rowData: {
      type: Object,
      default() {
        return {}
      }
    },
    colConfigs: {
      type: Array,
      default() {
        return []
      }
    },
    selectType: {
      type: String,
      default: 'SINGLE'
    }
  },
  methods: {
    handleClick() {
      this.rowData.checked = !this.rowData.checked
      this.$emit('select', this.rowData)
    }
  }
}
</script>

<style lang="scss">
.select-data-option {
  display: flex;
  align-items: center;
  border: 1px solid $--app-form-item-border-color;
  background-color: $--app-box-bgColor;
  .select-data-option--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 3.43rem;
    color: $--app-notice-color;
    &.is-checked {
      color: $--app-primary-color;
    }
  }
  .select-data-option--body {
    flex: 1;
    .list-card {
      max-height: none !important;
      margin-bottom: 0;
    }
  }
}
</style>
